import { SvgProps } from '../SvgRendererTypes';

export const MissingPetsIcon = ({ fillColor, ...props }: SvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Missing Pets Icon</title>
      <g>
        <path
          fill={fillColor}
          d="M13.01,10.8c-0.57-0.55-1.28-0.8-2.07-0.82c-0.79,0-1.48,0.27-2.07,0.82c-0.43,0.41-0.84,0.83-1.24,1.27
		c-0.77,0.82-0.89,2.01-0.32,2.95c0.45,0.74,1.23,1.17,2.06,1.17c0.24,0,0.49-0.04,0.73-0.11c0.29-0.1,0.56-0.13,0.84-0.13
		s0.56,0.05,0.85,0.15c0.24,0.07,0.49,0.11,0.72,0.11c0.82,0,1.59-0.43,2.04-1.16c0.57-0.91,0.47-2.11-0.27-2.93
		C13.89,11.66,13.45,11.22,13.01,10.8z M13.53,14.39c-0.23,0.37-0.61,0.59-1.01,0.59c-0.12,0-0.23-0.02-0.35-0.06
		c-0.41-0.13-0.82-0.2-1.23-0.2c-0.4,0-0.8,0.06-1.22,0.2c-0.12,0.04-0.23,0.06-0.35,0.06c-0.41,0-0.79-0.22-1.02-0.6
		c-0.29-0.48-0.22-1.06,0.17-1.48c0.45-0.49,0.84-0.87,1.2-1.22c0.34-0.33,0.73-0.48,1.22-0.48c0.5,0,0.89,0.16,1.22,0.48
		c0.47,0.45,0.88,0.87,1.23,1.26C13.77,13.33,13.83,13.94,13.53,14.39z"
        />
        <path
          fill={fillColor}
          d="M9.7,9.42c0.54-0.15,0.82-0.55,0.94-1.07c0.04-0.13,0.04-0.27,0.04-0.37c-0.01-0.67-0.23-1.22-0.72-1.62
		C9.25,5.77,8.29,6,7.95,6.87C7.66,7.64,7.8,8.36,8.35,8.98C8.7,9.38,9.17,9.56,9.7,9.42z"
        />
        <path
          fill={fillColor}
          d="M13.5,9.03c0.4-0.4,0.58-0.89,0.58-1.49c0-0.06,0-0.13-0.01-0.22c-0.07-0.57-0.33-1.04-0.9-1.23
		c-0.57-0.2-1.05,0.02-1.42,0.44c-0.49,0.55-0.65,1.21-0.44,1.91C11.6,9.52,12.73,9.8,13.5,9.03z"
        />
        <path
          fill={fillColor}
          d="M8.08,10.32c0-0.94-0.54-1.69-1.25-1.9c-0.67-0.2-1.3,0.18-1.46,0.85c-0.18,0.71,0.17,1.54,0.82,1.93
		c0.41,0.26,0.84,0.32,1.28,0.09C7.9,11.04,8.07,10.64,8.08,10.32z"
        />
        <path
          fill={fillColor}
          d="M14.8,8.53c-0.62,0.33-0.93,0.88-0.97,1.44c-0.02,1.05,0.68,1.63,1.5,1.4c0.77-0.22,1.36-1.12,1.25-1.91
		C16.46,8.54,15.6,8.09,14.8,8.53z"
        />
        <path
          fill={fillColor}
          d="M21.71,19.46l-1.61-1.61l-1.65-1.65c0.98-1.46,1.56-3.21,1.56-5.11c0-5.02-4.03-9.09-9-9.09c-4.97,0-9,4.07-9,9.09
		c0,5.02,4.03,9.09,9,9.09c1.95,0,3.76-0.64,5.23-1.7l0.06,0.06c0,0,0,0,0,0l3.17,3.17c0.2,0.2,0.45,0.29,0.71,0.29
		s0.51-0.1,0.71-0.29l0.83-0.83C22.1,20.48,22.1,19.85,21.71,19.46z M11,19.18c-4.41,0-8-3.63-8-8.09C3,6.63,6.59,3,11,3
		c4.41,0,8,3.63,8,8.09C19.01,14.98,15.78,19.18,11,19.18z M17.02,17.84l0.02-0.02c0.2-0.18,0.39-0.38,0.58-0.58l0.23-0.23
		l0.83,0.83l-0.83,0.83L17.02,17.84z M20.17,21l-1.61-1.61l0.83-0.83L21,20.17L20.17,21z"
        />
      </g>
    </svg>
  );
};
